var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('h3',[_vm._v("redirect")]),_c('v-btn',{on:{"click":_vm.token}},[_vm._v("token")]),_c('v-card',[_vm._v(_vm._s(_vm.jwt))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }